import jot from '../jot'
import _ from 'lodash'


const DIFF_NEW = 'N'
const DIFF_DELETE = 'D'
const DIFF_EDIT = 'E'
const DIFF_ARRAY = 'A'


export default {
    serialize: function(jots) {
        return _.map(jots, (jot) => jot.serialize())
    },

    toList: function(jots) {
        return new jot.LIST(jots)
    },

    fromDiff: function(diffList, format) {
        let jots = _.filter(
            _.flatMap(diffList, (diff) => {
                return this.handleDiff(diff)
            })
        )

        if (jots.length === 0) {
            return null
        }

        format = format || this.toList

        return format(jots)
    },

    handleDiff: function(diff) {
        switch (diff.kind) {
            case DIFF_NEW: // new
                return this.put(diff.path, diff.rhs)
            case DIFF_DELETE: // delete
                return this.remove(diff.path, diff.lhs)
            case DIFF_EDIT: // edit
                return this.set(diff.path, diff.lhs, diff.rhs)
            case DIFF_ARRAY: // array
                return this.array(diff.path, diff.index, diff.item)
                break
        }
    },

    reduce: function(path, jotAcc) {
    /*
      Takes a path: ['the', 'path']

      and builds up a JOT with this structure:

      jot.OBJECT_APPLY(
        'the',
        jot.OBJECT_APPLY(
          'path',
          jotAcc
        )
      )

    */

        if (path.length === 0) {
            return jotAcc
        }

        return _.reduce(_.reverse(path), (jotAcc, pathItem) => {
            if (_.isInteger(pathItem)) {
                return new jot.ARRAY_APPLY(pathItem, jotAcc)
            } else {
                return new jot.OBJECT_APPLY(pathItem, jotAcc)
            }
        }, jotAcc)
    },

    put: function(path, newValue) {
        let jotAcc = new jot.PUT(_.last(path), newValue)

        return this.reduce(_.slice(path, 0, -1), jotAcc)
    },

    remove: function(path, oldValue) {
        let jotAcc = new jot.REM(_.last(path), oldValue)

        return this.reduce(_.slice(path, 0, -1), jotAcc)
    },

    set: function(path, oldValue, newValue) {
        let jotAcc = new jot.SET(oldValue, newValue)

        return this.reduce(path, jotAcc)
    },

    array: function(path, index, childDiff) {
        let jotAcc = null

        switch (childDiff.kind) {
            case DIFF_NEW:
                jotAcc = new jot.INS(index, _.castArray(childDiff.rhs))
                break
            case DIFF_DELETE:
                jotAcc = new jot.DEL(index, _.castArray(childDiff.lhs))
                break
            case DIFF_EDIT:
                jotAcc = new jot.SET(childDiff.lhs, childDiff.rhs)
                break
            default:
                break
        }

        if (_.isNull(jotAcc)) {
            return null
        }

        return this.reduce(path, jotAcc)
    },
}
